import { useQuery } from "react-query";

import { queryKeys } from "../../../queries/keys";
import { getHomeSummary } from "../api/home.api";
import type { HomeScope } from "../types/home.types";

/**
 * O Início acompanha o dia a dia: diferente do padrão do app (5 min de cache,
 * sem buscar ao montar), ele busca de novo toda vez que a tela abre ou volta
 * a ter foco, mostrando os números anteriores enquanto os novos chegam.
 */
export const HOME_FRESH_QUERY = {
  staleTime: 0,
  refetchOnMount: true,
  refetchOnWindowFocus: true,
} as const;

/**
 * Indicadores do Início. Trocar o escopo só troca a chave: os números são
 * recalculados sem recarregar a página, mantendo os anteriores na tela
 * enquanto os novos chegam.
 */
export function useHomeSummary(scope?: HomeScope) {
  return useQuery(queryKeys.homeSummary(scope), () => getHomeSummary(scope), {
    ...HOME_FRESH_QUERY,
    keepPreviousData: true,
  });
}
